<template>
  <div :style="emStyle">
    <div class="top">
      <div>
        <img :src="logo" alt="" style="width: 40%; height: 40%" />
      </div>
      <div style="display: flex; align-items: center">
        <div>{{ username }}</div>
        <div style="margin-left: 5px">
          <img :src="tx" alt="" />
        </div>
        <i
          class="el-icon-switch-button"
          style="font-size: 25px; cursor: pointer"
          @click="loginOut"
        ></i>
      </div>
    </div>
    <div class="bottom">
      <div class="left-part" v-if="showMenu">
        <sidebar></sidebar>
      </div>
      <div class="right-part">
        <div v-if="showToRelease" style="display:flex;justify-content:flex-end;margin-bottom: 20px">
          <el-button
            type="primary"
            size="small"
            @click="toRelease"
            style="background: #0061C4;border: 1px solid #0061C4;"
          >履职发布</el-button>
        </div>
        <div class="main-container">
          <router-view :key="key" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { loginOut } from '@/api/user'
import em from '@/mixins/em.js'
import tx from '../../assets/tx@2x.png'
import logo from '@/assets/homePage/logo.png'
import sidebar from '../../components/sidebarF/index'
import { getItem } from '../../utils/storage.js'
import store from '@/store'
// import { 履职管理, 建议议案, 学习园地, 会议管理, 选民之声, 代表管理, 宣传管理, 资料库, 选民登记, 系统管理, 通知管理, 人大票决 } from '@/constant/rolesMap'
const fullWidth = 1920
const fullHeight = 960
export default {
  name: 'layoutT',
  components: {
    sidebar
  },
  mixins: [em],
  data () {
    return {
      fullWidth: fullWidth,
      fullHeight: fullHeight,
      emStyle: {
        width: fullWidth + 'px',
        height: fullHeight + 'px'
      },
      username: getItem('userInfo').username || '',
      tx: tx,
      logo: logo,
      key: this.$route.path,
      showMenu: store.getters.showMenu, // 是否显示左侧菜单
      showToRelease: false // 是否显示跳转履职发布按钮
    }
  },
  created () {
    if (this.$route.name === 'release') {
      this.showToRelease = false
    } else {
      this.isShowRelease()
    }
  },
  methods: {
    loginOut () {
      this.$confirm('确定退出当前登录吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        loginOut().then((res) => {
          if (res.data.code === 200) {
            localStorage.clear()
            sessionStorage.clear()
            this.$router.push('/login')
          } else {
            this.$message.warning(res.data.msg || res.data.data)
          }
        })
      })
    },
    isShowRelease () {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      userInfo.menuAuthority.forEach((x) => {
        if (x.code === 'DBFW') {
          const childCodeList = x.childList.map(y => y.code)
          if (childCodeList.includes('DBFW-DBLZ-LZFB')) {
            this.showToRelease = true
          }
        }
      })
    },
    toRelease () {
      sessionStorage.setItem('routerInfo', JSON.stringify({ code: this.$route.meta.roles[0].split('-')[0], path: this.$route.path }))
      this.$router.push('/release')
    }
  },
  computed: {},
  watch: {
    $route (route) {
      if (route.name === 'layout') {
        this.$router.push('/')
      }
      if (route.name === 'release') {
        this.showToRelease = false
      } else {
        this.isShowRelease()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.top {
  justify-content: space-between !important;
  height: 90px;
  background: url(../../assets/homePage/topBackground.png) no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: end;
  padding-left: 41px;
  padding-right: 83px;
  width: 100%;
  box-sizing: border-box !important;
}
.bottom {
  width: 100%;
  height: 100%;
  display: flex;
  box-sizing: border-box !important;
  .left-part {
    width: 247px;
    border-right: 1px solid #e8e8e8;
    border-top: 0;
    margin-top: 1px;
    /* height: 812px; */
    background: #f6f6f6;
    box-shadow: 0px 0px 25px 0px rgba(23, 0, 1, 0.08);
  }
  .right-part {
    height: 800px;
    overflow: auto;
    flex: 1;
    padding: 22px;
  }
  .main-container {
    background: #ffffff;
    border-radius: 5px;
    box-shadow: 0px 0px 10px 5px rgb(224, 224, 224);
    height: 100%;
    // padding: 60px 52px 40px 50px;
  }
}
</style>
